import React, { useState } from "react";
import "./News.css";
import Overlay from "../Overlay/Overlay";
export const generateRandomGradient = () => {
  const colors = [
    "#FF6B6B",
    "#FF9F43",
    "#FFD93D",
    "#6BCB77",
    "#4D96FF",
    "#A6A6A6",
    "#FF7F50",
  ];
  const color1 = colors[Math.floor(Math.random() * colors.length)];
  const color2 = colors[Math.floor(Math.random() * colors.length)];
  return `linear-gradient(135deg, ${color1}, ${color2})`;
};
const NewsCard = ({ title, text }) => {
  return (
    <div
      // className="news-card"
      style={{
        width: "100%",
        margin: "5px 20px",
        // padding: "16px",
        // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        backgroundColor: "#fff",
      }}
    >
      <div
        className="news-title"
        style={{ fontSize: "1.3rem", fontWeight: "bold", color: "#555" }}

        // sx={{
        //   fontSize: "1.3em",
        //   fontWeight: "bold",
        //   color: "#555",
        // }}
      >
        {title}
      </div>
      <div className="news-content" style={{}}>
        <p
          className="news-text"
          style={{ fontSize: "0.8rem", margin: 0, marginTop: 5 }}
        >
          {text}
        </p>
      </div>
    </div>
  );
};

export default NewsCard;
